webpackJsonp([108352454933461],{

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InsightPageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _seo = __webpack_require__(53);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _linkBack = __webpack_require__(97);
	
	var _linkBack2 = _interopRequireDefault(_linkBack);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsightPage = function InsightPage(_ref) {
	    var data = _ref.data;
	
	    var page = data.page.edges[0].node;
	    var allInsights = (0, _getContents.stripNode)(data.allInsights.edges);
	    var relatedInsights = (0, _getContents.filterByTag)(page.tag.tag, allInsights);
	
	    var seo = {
	        title: page.title,
	        description: page.intro,
	        image: page.image.sizes.src
	    };
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_seo2.default, seo),
	        _react2.default.createElement(_linkBack2.default, {
	            parent: {
	                slug: 'insights',
	                pageName: 'Insights'
	            },
	            className: 'on-insights'
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: 'section indented-contents gray-dividers' },
	            _react2.default.createElement('div', { className: 'mt-60' }),
	            _react2.default.createElement(_components2.default, {
	                content: _extends({
	                    __typename: 'insight'
	                }, page)
	            }),
	            _react2.default.createElement(_components2.default, {
	                content: {
	                    __typename: 'DatoCmsLinksToInsight',
	                    title: 'Related insights'
	                },
	                ignoreIndent: true,
	                insights: allInsights
	            })
	        )
	    );
	};
	
	exports.default = InsightPage;
	var InsightPageQuery = exports.InsightPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-insight-template-js-0d9ec4de8003e84a2c5f.js